import { createRouter, createWebHistory } from 'vue-router'
import FinanceLayout from './layouts/FinanceLayout.vue'
import FinanceLogin from './views/FinanceLogin.vue'
import Dashboard from './views/Dashboard.vue'
import Transactions from './views/Transactions.vue'
import CommissionPlans from './views/CommissionPlans.vue'
import CommissionRules from './views/CommissionRules.vue'
import Expenses from './views/Expenses.vue'
import Receivables from './views/Receivables.vue'
import Receipts from './views/Receipts.vue'
import OtherIncome from './views/OtherIncome.vue'
import ExpenseCategories from './views/ExpenseCategories.vue'
import Payables from './views/Payables.vue'
import Payouts from './views/Payouts.vue'
import Accounts from './views/Accounts.vue'
import AccountFlows from './views/AccountFlows.vue'
import MonthCloses from './views/MonthCloses.vue'
import Reports from './views/Reports.vue'
import Branches from './views/Branches.vue'
import Employees from './views/Employees.vue'
import Teams from './views/Teams.vue'
import Adjustments from './views/Adjustments.vue'
import PaymentMethods from './views/PaymentMethods.vue'
import Profile from './views/Profile.vue'
import Logs from './views/Logs.vue'
import Migration from './views/Migration.vue'
import MonthlyDetail from './views/MonthlyDetail.vue'
import { getFinanceToken } from './api/financeRequest'

const reportRoute = (path, title, reportType) => ({
  path,
  component: Reports,
  meta: { title, reportType },
})
const routes = [
  {
    path: '/finance/login',
    component: FinanceLogin,
    meta: { title: '财务登录', public: true },
  },
  {
    path: '/finance',
    component: FinanceLayout,
    redirect: '/finance/dashboard',
    children: [
      { path: 'dashboard', component: Dashboard, meta: { title: '财务概览' } },
      {
        path: 'transactions',
        component: Transactions,
        meta: { title: '成交报告' },
      },
      {
        path: 'receivables',
        component: Receivables,
        meta: { title: '佣金应收' },
      },
      { path: 'receipts', component: Receipts, meta: { title: '收款流水' } },
      {
        path: 'other-income',
        component: OtherIncome,
        meta: { title: '其他收入' },
      },
      {
        path: 'commission/plans',
        component: CommissionPlans,
        meta: { title: '佣金方案' },
      },
      {
        path: 'commission/branches',
        component: CommissionRules,
        meta: { title: '分部规则' },
      },
      {
        path: 'commission/teams',
        component: Teams,
        meta: { title: '小组与组长' },
      },
      {
        path: 'commission/adjustments',
        component: Adjustments,
        meta: { title: '佣金调整' },
      },
      { path: 'expenses', component: Expenses, meta: { title: '支出流水' } },
      {
        path: 'expenses/categories',
        component: ExpenseCategories,
        meta: { title: '支出分类' },
      },
      {
        path: 'payouts/payables',
        component: Payables,
        meta: { title: '员工应发' },
      },
      {
        path: 'payouts/records',
        component: Payouts,
        meta: { title: '发放记录' },
      },
      { path: 'accounts', component: Accounts, meta: { title: '资金账户' } },
      {
        path: 'accounts/flows',
        component: AccountFlows,
        meta: { title: '资金流水' },
      },
      {
        path: 'settlements/monthly',
        component: MonthCloses,
        meta: { title: '月度结账' },
      },
      reportRoute('settlements/branches', '分部结算', 'branch-settlements'),
      reportRoute('settlements/company', '公司汇总', 'company-settlements'),
      reportRoute('reports/performance', '个人业绩', 'performance'),
      reportRoute('reports/team-leaders', '组长奖金', 'team-leaders'),
      reportRoute('reports/branches', '分部利润', 'branch-profit'),
      reportRoute('reports/company', '公司利润', 'company-profit'),
      reportRoute('reports/receivables', '应收账款', 'receivables'),
      reportRoute('reports/income-expense', '收支明细', 'income-expense'),
      reportRoute('reports/accounts', '账户对账', 'accounts'),
      reportRoute('reports/exports', '报表导出', 'company-profit'),
      { path: 'reports/monthly-detail', component: MonthlyDetail, meta: { title: '月度业绩明细' } },
      {
        path: 'settings/branches',
        component: Branches,
        meta: { title: '分部维护' },
      },
      {
        path: 'settings/employees',
        component: Employees,
        meta: { title: '员工归属' },
      },
      { path: 'settings/teams', component: Teams, meta: { title: '小组成员' } },
      {
        path: 'settings/payment-methods',
        component: PaymentMethods,
        meta: { title: '支付方式' },
      },
      {
        path: 'settings/profile',
        component: Profile,
        meta: { title: '当前管理员' },
      },
      { path: 'system/logs', component: Logs, meta: { title: '操作日志' } },
      {
        path: 'system/migration',
        component: Migration,
        meta: { title: '历史迁移' },
      },
    ],
  },
]
export const financeRoutes = routes
export const financeGuard = (to) => {
  if (to.path.startsWith('/finance') && !to.meta.public && !getFinanceToken())
    return { path: '/finance/login', query: { redirect: to.fullPath } }
}
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})
router.beforeEach(financeGuard)
export default router
